const MetadonnesIntegrated = ({language , token}) => {
    const newMetadonnesIframe = "https:" +
    window.process.env.URL_metaData
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_metadonnes_display"
        src={newMetadonnesIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default MetadonnesIntegrated